import { Card, CardContent, Stack, Typography } from "@mui/material"
import { VisitFrequencyChart } from "./visit-frequency-chart"

export function CostVisitSnapshotCard({ costResult, currencySymbol }) {
    const snapshot = costResult?.visitSnapshot

    return (
        <Card sx={{ flex: 1 }}>
            <CardContent sx={{ p: 3 }}>
                <Stack spacing={2.5}>
                    <Typography variant="h6" sx={{ fontSize: "18px !important" }}>
                        Visit Frequency Breakdown
                    </Typography>
                    <VisitFrequencyChart visitSnapshot={snapshot} currencySymbol={currencySymbol} />
                </Stack>
            </CardContent>
        </Card>
    )
}
